// Shared constants for onboarding questions

export const FEATURE_OPTIONS = [
  {
    value: "professional",
    key: "welcome.greetings.features.professional_profile",
  },
  {
    value: "social",
    key: "welcome.greetings.features.social_accounts",
  },
  {
    value: "onlyfans",
    label: "😈 OnlyFans",
  },
  {
    value: "videos",
    key: "welcome.greetings.features.ai_videos",
  },
  {
    value: "outfits",
    key: "welcome.greetings.features.looks_outfits",
  },
  {
    value: "hairstyles",
    key: "welcome.greetings.features.hairstyles",
  },
  {
    value: "memes",
    key: "welcome.greetings.features.memes_stickers",
  },
  {
    value: "dating",
    key: "welcome.greetings.features.dating_photos",
  },
  {
    value: "editing",
    key: "welcome.greetings.features.photo_editing",
  },
] as const;

export const SOURCE_OPTIONS = [
  {
    value: "google",
    key: "welcome.greetings.sources.google_search",
  },
  {
    value: "tiktok",
    key: "welcome.greetings.sources.tiktok",
  },
  {
    value: "reddit",
    key: "welcome.greetings.sources.reddit",
  },
  {
    value: "friends",
    key: "welcome.greetings.sources.friends",
  },
  {
    value: "ad",
    key: "welcome.greetings.sources.online_ad",
  },
  {
    value: "news",
    key: "welcome.greetings.sources.news_article",
  },
] as const;
